import { render } from "./list-bank-account.vue?vue&type=template&id=545d08b2"
import script from "./list-bank-account.vue?vue&type=script&lang=js"
export * from "./list-bank-account.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__